<template>
  <li @click.stop="changeState">
    <el-checkbox v-model="item.config_checked" disabled></el-checkbox>

    <i class="myIcon" :class="icon"></i>

    <div>
      {{ name }}
      <div class="deptName" v-if="isSearch && item.deptName">{{ item.deptName }}</div>
    </div>

    <div v-if="item.valueType === 'dept'" class="fun" @click.stop>
      <el-switch
        v-model="item.config_includeChild"
        :title="item.csonfig_includeChild ? '包含' : '不包含'"
      />

      <span
        class="includeChild"
        title="下級"
        :class="item.config_includeChild ? 'active' : ''"
        @click="toChild(item)"
      >
        包含下級
      </span>

      <i class="el-icon-arrow-right" title="下級" @click="toChild(item)"></i>
    </div>
  </li>
</template>

<script>
export default {
  name: "orgNode",
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    isSearch: {
      type: Boolean,
      default: false
    }
  },
  inject: {
    $orgBox: {
      default: null,
    },
    $orgList: {
      default: null,
    },
  },
  created() {
    if (this.$orgList.isCheckedAll) {
      this.item.config_checked = true;
    }
    /**
     * 刚进来的时候result里面有，就是真的有，没有就是没有
     */
  },
  watch: {
    "item.config_checked": {
      immediate: true,
      handler(n, o) {
        if (!dsf.isUnDef(o) || n) {
          this.$orgList.changeCheckState(this.item);
        }
      },
    },
  },
  computed: {
    icon() {
      return [
        "iconfont " +
          (this.item.valueType === "dept"
            ? "icon-icon_user_bm"
            : "icon-icon-user"),
      ];
    },
    name() {
      let str = this.item.name;
      if (this.item.quantity) {
        str += "(" + this.item.quantity + ")";
      }
      return str;
    },
  },
  methods: {
    toChild() {
      this.$orgBox.toChild(this.item);
    },
    changeState() {
      this.item.config_checked = !this.item.config_checked;
    },
  },
};
</script>
